/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface HealthCheckResultDto
 */
export interface HealthCheckResultDto {

    /**
     * Overall health status
     *
     * @type {string}
     * @memberof HealthCheckResultDto
     * @example ok
     */
    status: HealthCheckResultDtoStatusEnum;

    /**
     * Per-indicator results keyed by indicator name
     *
     * @type {{ [key: string]: any; }}
     * @memberof HealthCheckResultDto
     * @example {"database":{"status":"up"},"redis":{"status":"up"}}
     */
    details: { [key: string]: any; };
}

/**
 * @export
 * @enum {string}
 */
export enum HealthCheckResultDtoStatusEnum {
    Error = 'error',
    Ok = 'ok',
    ShuttingDown = 'shutting_down'
}

